export default "__VITE_ASSET__DEW7LDWY__"